const R2_BASE = "https://assets.wordaliveglobal.org";

/**
 * Resolve image URLs: R2 pass-through, local paths → R2, blank → fallback.
 * Handles stale production DB records that still have /api/uploads/ paths.
 */
export function resolveImageUrl(url, fallback = null) {
  if (!url) return fallback;
  if (url.startsWith(R2_BASE) || url.startsWith("http")) return url;
  if (url.startsWith("/api/uploads/")) return R2_BASE + url.replace("/api/uploads", "");
  if (url.startsWith("/uploads/")) return R2_BASE + url.replace("/uploads", "");
  return url;
}
